var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOrganizations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15C1.0875 15 0.734375 14.8531 0.440625 14.5594C0.146875 14.2656 0 13.9125 0 13.5V4.5C0 4.0875 0.146875 3.73438 0.440625 3.44063C0.734375 3.14688 1.0875 3 1.5 3H4V1.49562C4 1.08187 4.14688 0.729167 4.44063 0.4375C4.73438 0.145833 5.0875 0 5.5 0H10.5C10.9125 0 11.2656 0.146876 11.5594 0.440626C11.8531 0.734376 12 1.0875 12 1.5V3H14.5C14.9125 3 15.2656 3.14688 15.5594 3.44063C15.8531 3.73438 16 4.0875 16 4.5V13.5C16 13.9125 15.8531 14.2656 15.5594 14.5594C15.2656 14.8531 14.9125 15 14.5 15H1.5ZM5.5 3H10.5V1.5H5.5V3ZM14.5 10.25H10.5V12H5.5V10.25H1.5V13.5H14.5V10.25ZM7 10.5H9V8.5H7V10.5ZM1.5 8.75H5.5V7H10.5V8.75H14.5V4.5H1.5V8.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrganizations);
export default __webpack_public_path__ + "static/media/icon-organizations.a249a2634852ab997e8183cce047ceb9.svg";
export { ForwardRef as ReactComponent };